import React from 'react';
import logoText from '@assets/logo.png';
import { Card } from '@components/atoms/Card';
import { Button } from '@components/atoms/Button';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '@hooks/useTranslation';

const OrganizationDisabled: React.FC = () => {
  // Sprint 28, story-143. Bucket 2 — see docs/architecture.md "## Sprint 28" Decision 4.
  const tOrgLifecycle = useTranslation('orgLifecycle');
  const history = useHistory();

  return (
    <div className="flex flex-col gap-10 items-center justify-center min-h-screen bg-indigo-950 dark:bg-neutral-900 p-4">
      <img
        src={logoText}
        alt="App usage info"
        className="max-w-sm w-full mb-4 md:mb-0 md:mr-6"
      />

      <Card className="max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6">
        <div>
          <h1 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            {tOrgLifecycle.organizationDisabledTitle}
          </h1>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
            {tOrgLifecycle.organizationDisabledMessage}
          </p>
          <div className="flex justify-center mt-6">
            <Button variant="primary" onClick={() => history.push('/login')}>
              {tOrgLifecycle.tryAgain}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default OrganizationDisabled;
